import { CheckList } from "src/newComponents/CheckList";
import MoneyBackGuaranteeButton from "src/pages/products/components/MoneyBackGuaranteeButton";

const GPHCBenefits = () => {
  return (
    <div style={{ maxWidth: "600px" }}>
      <CheckList
        items={[
          "95% pass rate for previous GPhC exams",
          "Trusted by over 5500 Trainees with GPhC exam revision",
          "Instant access! Start your revision after checkout",
          "Regular updates included",
          <>
            <MoneyBackGuaranteeButton title="Money back / free extension policy" renderAsButton={false} /> available on
            the Foundation Pharmacist Training Programme only
          </>,
        ]}
      />
    </div>
  );
};

export { GPHCBenefits };
